import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfServiceSandboxPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        <div className="container mx-auto px-4 py-16 max-w-3xl">
          <h1 className="text-4xl font-bold mb-2" style={{ color: '#214140' }}>
            Terms of Service
          </h1>
          <p className="text-sm text-gray-500 mb-10">Last updated: September 23, 2026</p>

          <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>1. Acceptance of Terms</h2>
              <p>
                By accessing or using the Nursetech Medical™ Corp. ("Nursetech Medical™," "we," "us," or
                "our") website at nursetechmedical.com and any related services, you agree to be bound
                by these Terms of Service. If you do not agree to these terms, please do not use our
                website or services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>2. Description of Services</h2>
              <p>
                Nursetech Medical™ provides medical device products, including the Cordflex® line management
                system, along with related educational resources, training materials, and support services.
                Our website allows users to learn about our products, request samples and trials, place
                orders, and access resources.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>3. Use of Website</h2>
              <p className="mb-3">You agree to use our website only for lawful purposes and in accordance with these Terms. You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the website in any way that violates applicable laws or regulations</li>
                <li>Attempt to gain unauthorized access to any part of the website or its systems</li>
                <li>Use the website to transmit any harmful, offensive, or unlawful content</li>
                <li>Interfere with or disrupt the website or servers connected to it</li>
                <li>Use automated systems to scrape, crawl, or extract data from the website</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>4. Products and Orders</h2>
              <p>
                All product descriptions, pricing, and availability are subject to change without notice.
                We reserve the right to limit quantities, refuse orders, and cancel orders at our
                discretion. Pricing errors do not obligate us to fulfill orders at incorrect prices.
              </p>
              <p className="mt-3">
                Product images are for illustrative purposes and may not exactly represent the product
                received. Please refer to product specifications for detailed information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>5. Medical Device Disclaimer</h2>
              <p>
                Cordflex is a Class I, 510(k)-exempt medical device listed with FDA, intended for use by healthcare professionals and
                trained caregivers. The information on our website is provided for informational purposes and
                does not constitute medical advice. Always follow your institution's protocols and the
                product's instructions for use. Nursetech Medical™ is not responsible for improper use of
                its products.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>6. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos, images, and software, is
                the property of Nursetech Medical™ or its content suppliers and is protected by United
                States and international intellectual property laws. You may not reproduce, distribute,
                modify, or create derivative works from any content without our prior written consent.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>7. User Submissions</h2>
              <p>
                Any information, feedback, testimonials, or materials you submit to us through the
                website become our property. By submitting content, you grant us a non-exclusive,
                royalty-free, perpetual license to use, reproduce, modify, and distribute such content
                in connection with our business.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>8. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Nursetech Medical™ shall not be liable for any
                indirect, incidental, special, consequential, or punitive damages arising from your use
                of the website or our products. Our total liability shall not exceed the amount you paid
                for the specific product or service giving rise to the claim.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>9. Disclaimer of Warranties</h2>
              <p>
                The website and its content are provided "as is" and "as available" without warranties
                of any kind, either express or implied. We do not warrant that the website will be
                uninterrupted, error-free, or free of viruses or other harmful components.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>10. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Nursetech Medical™, its officers, directors,
                employees, and agents from any claims, damages, losses, or expenses arising from your
                use of the website or violation of these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>11. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the State
                of Delaware, without regard to its conflict of law provisions. Any disputes arising
                under these Terms shall be resolved in the courts located in Delaware.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>12. SMS and Phone Communications</h2>
              <p className="mb-3">
                You agree to receive information messages (appointment reminders, account notifications, etc.)
                from Nursetech Medical. Message frequency varies. Message and data rates may apply. For help,
                reply HELP or email us at david@nursetechmedical.com. You can opt out at any time by replying STOP.
              </p>
              <p className="mb-3">
                Customers may opt in by entering their phone number at{' '}
                <a href="https://nursetechmedical.com/sample-request" className="underline">nursetechmedical.com/sample-request</a>,{' '}
                <a href="https://nursetechmedical.com/trial-request" className="underline">nursetechmedical.com/trial-request</a>, or{' '}
                <a href="https://nursetechmedical.com/contact" className="underline">nursetechmedical.com/contact</a> and
                checking a consent checkbox. The form states that they agree to receive SMS messages and phone
                calls from Nursetech Medical. The customer is also notified that message frequency may vary,
                message and data rates may apply, and that they can reply STOP to opt out or HELP for
                assistance. Links to our Terms of Service and Privacy Policy are provided on the form.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Automated and AI-assisted communications:</strong> Messages and calls may be sent or placed using automated technology, including autodialers, artificial or prerecorded voices, and AI-powered voice and text assistants acting on behalf of Nursetech Medical.</li>
                <li><strong>Message types:</strong> Follow-up on your request, sample and trial coordination, product information, support, and marketing.</li>
                <li><strong>Frequency and cost:</strong> Message frequency may vary. Message and data rates may apply.</li>
                <li><strong>Opt out:</strong> Reply STOP to any text message to stop receiving texts. You may also ask to be removed during any call, or email info[at]nursetechmedical.com.</li>
                <li><strong>Help:</strong> Reply HELP to any text message or email info[at]nursetechmedical.com.</li>
                <li><strong>Consent is optional:</strong> Consent is not a condition of purchase or of submitting any form.</li>
                <li>Carriers are not liable for delayed or undelivered messages.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>13. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. Changes will be posted on this
                page with an updated "Last updated" date. Your continued use of the website after
                changes are posted constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3" style={{ color: '#214140' }}>14. Contact Us</h2>
              <p>
                If you have questions about these Terms of Service, please contact us:
              </p>
              <p className="mt-3">
                Nursetech Medical™ Corp.<br />
                8 The Green, Ste A<br />
                Dover, DE 19901<br />
                Email: legal[at]nursetechmedical.com
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfServiceSandboxPage;
